<template>
  <div class="overlay-pill d-flex align-items-center justify-content-center">
    <template v-if="isLoading">
      <v-loader white thin />
    </template>
    <template v-else>
      <v-icon v-if="icon" :icon="icon" size="1rem"></v-icon>
      <span
        class="overlay-pill__text d-inline-block text-small font-weight-semi-bold"
      >
        <slot />
      </span>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    icon: { type: String, default: null },
    isLoading: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.overlay-pill {
  background-color: rgba($color-rgb--grey-90, 0.24);
  backdrop-filter: blur(4px);
  color: $color-ui--white;
  height: $size--8;
  width: auto;
  border-radius: $size--10;
  padding: 0 $size--2;
  animation: fade-in 0.4s ease;

  .v-loader {
    height: $size--4;
    width: $size--4;
  }
}
.overlay-pill__text {
  margin-left: 2px;
}
</style>
